import api from "./client";

// --- Get all arrays ---
export const listArrays = async () => {
  const { data } = await api.get("/arrays/");
  return data;
};

// --- Get arrays by site ID ---
export const listArraysBySite = async (siteId) => {
  const { data } = await api.get(`/arrays/site/${siteId}`);
  return data;
};

// --- Get detailed arrays by site ID (used in Transformer Array Config table) ---
export const listArraysDetailedBySite = async (siteId) => {
  const { data } = await api.get(`/arrays/site/${siteId}/detailed`);
  return data;
};

// --- Create a new array ---
export const createArray = async (payload) => {
  const { data } = await api.post("/arrays/", payload);
  return data;
};

// --- Update an existing array (PUT) ---
export const updateArray = async (id, payload) => {
  const { data } = await api.put(`/arrays/${id}`, payload);
  return data;
};

// --- Delete an array ---
export const deleteArray = async (id) => {
  const { data } = await api.delete(`/arrays/${id}/`);
  return data;
};

// --- Check if array can be deleted (used for safety check before delete) ---
export const canDeleteArray = async (id) => {
  const { data } = await api.get(`/arrays/${id}/can_delete`);
  return data;
};
